import React from 'react';
import { SkipBankingButtonWithState as SkipBankingButton } from '../SkipBankingButton';

import styles from './Inverite.module.scss';

export default function InveriteView({
  iframeSrc,
  onIframeLoad,
  clientId,
  requestId,
  skipBankingSurvey,
  onSkipBanking,
  showButton,
}) {
  return (
    <div className={styles.container}>
      <iframe
        title="Inverite"
        className={styles.inverite}
        onLoad={onIframeLoad}
        src={iframeSrc}
        data-cy="inveriteIframe"
      />
      <SkipBankingButton
        clientId={clientId}
        requestId={requestId}
        skipBankingSurvey={skipBankingSurvey}
        onSkipBanking={onSkipBanking}
        showButton={showButton}
      />
    </div>
  );
}
